module.exports = __webpack_public_path__ + "img/reports_future_balance.41623968.png";